import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { forgottenPassword } from "../../api";
import TitleSubtitle from "../../components/common/TitleSubtitle";
import Button from "../../components/ui/Button";
import TextInput from "../../components/ui/TextInput";

const Forgotten: React.FC = () => {
    const navigate = useNavigate();
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    const [email, setEmail] = useState<string>("");
    const [registrationSuccess, setRegistrationSuccess] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>("");

    const handleRegister = async () => {
        try {
            await forgottenPassword({ email });
            setRegistrationSuccess(true);
        } catch (error) {
            console.error("Error registering:", error);
            setErrorMessage(t("requestFailed"));
        }
    };

    const isFormComplete = email.trim() !== "";

    return (
        <div className="login-container">
            {registrationSuccess ? (
                <div className="success-message">
                    <TitleSubtitle
                        title={t("thankYou")}
                        subtitle={t("youWillReceiveAnEmailFromTheRewindTeamWithYourNewPassword")}
                    />
                    <Button label={t("backToLogin")} variant="primary" onClick={() => navigate("/login")} />
                </div>
            ) : (
                <div>
                    <TitleSubtitle title={t("forgottenPassword")} subtitle="" />

                    <div className="register-form">
                        <TextInput
                            type="email"
                            placeholder={t("enterYourEmailMandatory")}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />

                        {errorMessage && <p className="error-message">{errorMessage}</p>}

                        <Button
                            label={t("submit")}
                            variant="primary"
                            onClick={handleRegister}
                            disabled={!isFormComplete}
                        />

                        <Button
                            label={t("backToLogin")}
                            variant="outline"
                            shape="pill"
                            onClick={() => navigate("/login")}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Forgotten;
